const EXPIRATION_NOTIFICATION_DATE_RANGES = [
  1, 3, 5, 7, 12, 21, 28, 30, 48, 56, 70
]

export default EXPIRATION_NOTIFICATION_DATE_RANGES
export { EXPIRATION_NOTIFICATION_DATE_RANGES }
